module.exports = __webpack_public_path__ + "i18n/de.b068fc48a2586b03878867953dc8d7bb.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/de.json
// module id = 847
// module chunks = 60